import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../apis/baseQuery';
import { API_CONSTANTS } from '../../utils/constants';

export type DashboardDateRange =
  | 'all'
  | 'last_month'
  | 'last_3_months'
  | 'last_6_months';

export interface DashboardKpiData {
  totalUsers: number;
  activeUsers: number;
  inactiveUsers: number;
  deletedUsers: number;
  deletedUsersPercentage: number;
  totalEvents: number;
  activeEventsRightNow: number;
  eventsFadedLast7Days: number;
  repeatEventCreatorsPercentage: number;
}

export interface DashboardKpiResponse {
  success: boolean;
  message: string;
  data: DashboardKpiData;
  meta: Record<string, unknown>;
}

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  tagTypes: ['DashboardKpi'],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getDashboardKpis: builder.query<DashboardKpiResponse, DashboardDateRange>({
      query: (dateRange = 'all') => ({
        url: API_CONSTANTS.ADMIN.ADMIN_KPI_URL,
        method: 'GET',
        params: { dateRange },
      }),
      providesTags: [{ type: 'DashboardKpi', id: 'SUMMARY' }],
    }),
  }),
});

export const { useGetDashboardKpisQuery } = dashboardApi;

export default dashboardApi;
